import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cloud-upload-alt mt-1" }, null, -1)
const _hoisted_2 = { class: "d-none d-md-block ms-2" }

import { blocklyStore } from '../../../blockly/blocklyStore';
import { translation } from '../../../lang/Translation';
import { MessageDialog } from '../../../../framework/frontend/MessageDialog';


export default /*#__PURE__*/_defineComponent({
  __name: 'SaveButton',
  setup(__props) {

const t = translation;
const save =async () => {
  try {
    await blocklyStore.save()
    MessageDialog.info(t.to("保存しました","save_success"))
  } catch (e) {
    MessageDialog.error(t.to("保存に失敗しました","save_failed"))
    
  }
};

const buttonName = t.to("保存","save")

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "d-flex me-2 btn btn-outline-secondary btn-lg",
    onClick: save
  }, [
    _hoisted_1,
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(buttonName)), 1)
  ]))
}
}

})